
import {
  restaurantCheckoutClient,
  restaurantOrdersClient,
  getConfig,
  useRestaurantCart,
  RestaurantCartProvider,
  RestaurantCheckout,
  useMenu,
  usePaymentConfig,
  useLocations,
  menuClient,
  cartClient,
  reservationClient,
  locationsClient,
  initSDK,
  validateConfig,
  isPreviewMode
} from '@happyspace/sdk';

// Reservations live in the /restaurant subpath (not the root export).
// Deals + Linked Accounts (franchise locations) do too — resolved at runtime
// via the import map, so they always match the server's shipped SDK bundle.
import {
  ReservationFlow,
  useReservationSlots,
  tableReservationClient,
  useDeals,
  useCheckoutDeals,
  dealsClient,
  useSiteLocations,
  useSelectedLocation,
  getSelectedLocationId,
  setSelectedLocationId,
  getSelectedLinkedBusinessId,
  setSelectedLinkedBusinessId,
  getEffectiveBusinessId
} from '@happyspace/sdk/restaurant';

export const checkoutClient = restaurantCheckoutClient;
export const ordersClient = restaurantOrdersClient;

export function getSiteConfig() {
  const config = getConfig();
  const sc = (typeof window !== 'undefined' && window.SITE_CONFIG) || {};
  return {
    businessId: config.businessId || sc.businessId || '',
    apiBaseUrl: config.apiBaseUrl || sc.apiBaseUrl || 'https://api.happyspace.one/api/v1',
    stripePublishableKey: sc.stripePublishableKey || '',
    taxRate: typeof sc.taxRate === 'number' ? sc.taxRate : 0.08
  };
}

export function generateCartItemKey(item) {
  const modKey = item.selectedModifiers
    ? JSON.stringify(item.selectedModifiers.map(m => m.optionId).sort())
    : '';
  return (item.id || item._id || '') + ':' + modKey;
}

export function calculateItemTotal(item) {
  let total = item.basePrice || item.price || 0;
  if (item.selectedModifiers) {
    for (const mod of item.selectedModifiers) total += mod.price || 0;
  }
  return total * (item.quantity || 1);
}

export {
  useRestaurantCart,
  RestaurantCartProvider,
  RestaurantCheckout,
  useMenu,
  usePaymentConfig,
  useLocations,
  menuClient,
  cartClient,
  reservationClient,
  locationsClient,
  initSDK,
  getConfig,
  validateConfig,
  isPreviewMode,
  ReservationFlow,
  tableReservationClient,
  useReservationSlots,
  useDeals,
  useCheckoutDeals,
  dealsClient,
  useSiteLocations,
  useSelectedLocation,
  getSelectedLocationId,
  setSelectedLocationId,
  getSelectedLinkedBusinessId,
  setSelectedLinkedBusinessId,
  getEffectiveBusinessId
};
